import { configureStore } from '@reduxjs/toolkit';
import { scenarioSlice } from './features/scenario.slice';
import { localStorageMiddleware } from './middleware';

export const store = configureStore({
    reducer: {
        [scenarioSlice.name]: scenarioSlice.reducer,
    },
    // Additional middleware can be passed to this array
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(localStorageMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
});
